import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers';
import {
  Country,
  EconomicActivity,
  LineOfBusiness,
  MonetaryInstrument,
  PayFormType,
  OperationType,
  IdentificationType,
  FederalEntity,
  FederalSecretary,
  TypeOfSocietyFinancial,
} from '../models/index';

@Injectable()
export class CatalogsService {
  private url: string;
  constructor(private httpClient: HttpClient, @Inject('API_URL') private apiUrl: string) {
    this.url = apiUrl + 'catalog/';
  }
  getCountries = (): Observable<Array<Country>> => this.httpClient.get<Array<Country>>(`${this.url}countries`);
  getEconomicActivities = (): Observable<Array<EconomicActivity>> => this.httpClient.get<Array<EconomicActivity>>(`${this.url}economic-activities`);
  getLinesOfBusiness = (): Observable<Array<LineOfBusiness>> => this.httpClient.get<Array<LineOfBusiness>>(`${this.url}lines-of-business`);
  getMonetaryInstruments = (): Observable<Array<MonetaryInstrument>> =>
    this.httpClient.get<Array<MonetaryInstrument>>(`${this.url}monetary-instruments`);
  getPayFormTypes = (): Observable<Array<PayFormType>> => this.httpClient.get<Array<PayFormType>>(`${this.url}payform-types`);
  getOperationTypes = (vulnerableActivityId: number): Observable<Array<OperationType>> =>
    this.httpClient.get<Array<OperationType>>(`${this.url}operation-types/${vulnerableActivityId}`);

  getIdentificationTypes = (): Observable<Array<IdentificationType>> =>
    this.httpClient.get<Array<IdentificationType>>(`${this.url}identification-types`);

  getFederalEntity = (): Observable<Array<FederalEntity>> => this.httpClient.get<Array<FederalEntity>>(`${this.url}federal-entities`);
  getFederalSecretaries = (): Observable<Array<FederalSecretary>> => this.httpClient.get<Array<FederalSecretary>>(`${this.url}federal-secretaries`);
  getTypesOfSocietiesFinancial = (): Observable<Array<TypeOfSocietyFinancial>> =>
    this.httpClient.get<Array<TypeOfSocietyFinancial>>(`${this.url}societies-financial`);
}
